export default __webpack_public_path__ + "static/media/signal71Mobile.71a90b96.jpg";